import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { IPgProps, ISearchPage } from "@/types/AppTypes";
import { globalPrompt } from "@/components/message";
import { warehouseService } from "./warehouseService";
import {
    IVRMWarehouseDetail,
    IVRMWarehouseSearchFields,
    IVRMWarehouseInsert,
    IVRMAreaDetail,
    IVRMAreaSearchFields,
    IVRMAreaInsert,
    IVRMAreaBatchInsert,
    IVRMAreaUpdate,
    IVRMAreaFormFields,
    IVRMShelvesUpdate,
    IVRMShelvesBatchInsert,
    IVRMShelvesInsert,
    IVRMShelvesDetail,
    IVRMShelvesSearch,
    IVRMShelvesFormFields,
    IVRMShelfUpdate,
    IVRMshelfDetail,
    IVRMshelfSearch,
    IVRMshelfInsert,
    IVRMShelfFormFields,
    IVRMshelfBatchInsert,
    IVRMshelfSearchFields
} from "./warehouseTypes";
import { sourceAppOrBranch } from "@/types/AppDictEnums";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination } from "@/utils/utils";


export interface IVRMTabsDrawerInfo {
    visible: boolean,
    mode: "add" | "edit"
}



export const useWarehouseModel = createModel(function () {
    const { user, shopAndOrg, setLoadingInfo } = useGlobalModel()
    const { user: { userName } } = useGlobalModel();
    /**
     * 仓库列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<IVRMWarehouseDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IVRMWarehouseSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //行选id
    const [selectedRowKeys, setSelectedRowKeys] = useState<string>("");
    const [saveLoading, setSaveLoading] = useState<boolean>(false); //  保存按钮
    //仓库列表查询
    const loadData = async (page?: ISearchPage, searchValue: IVRMWarehouseSearchFields = searchParam) => {

        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await warehouseService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IVRMWarehouseSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys("")
        loadData(initPgCfg, {})
    }
    /**
     * 仓库新增
     */
    const [addWareVisible, setAddWaerVisible] = useState<boolean>(false);

    //仓库新增 Api
    const insertWarehouse = async (data: IVRMWarehouseInsert) => {
        try {

            let params = {
                ...data,
                ...shopAndOrg,
                ...sourceAppOrBranch,
                // createUser: user.username,
            }
            let { retData } = await warehouseService.insert(params);
            retData ?
                loadData() && globalPrompt("message", { text: "仓库新增成功", type: "success" })
                : globalPrompt("message", { text: "仓库新增失败", type: "error" });
            setSaveLoading(false)
            return retData;
        } catch (error) {
            setSaveLoading(false)
        }
    }

    /** 
     * 仓库详情
     */
    const initWaerhouseFormVal = {
        id: "",
        shopId: "",
        shopName: "",
        orgCode: "",
        orgName: "",
        code: "",
        name: "",
        contact: "",
        phone: "",
        address: "",
        note: "",
        createTime: "",
        updateTime: "",
        // createUser: "",
        updateUser: "",
    }
    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<IVRMWarehouseDetail>(initWaerhouseFormVal);

    //表单修改
    const updateEditFormVal = (val: IVRMWarehouseDetail | null) => {
        setEditFormVal(val ? { ...editFormVal, ...val } : initWaerhouseFormVal);
    }

    //获取一条详情数据 Api
    const getWarehouseOne = async (id: string) => {
        let { retData } = await warehouseService.one(id);
        retData && setEditFormVal(retData);
    }

    //表单编辑 Api
    const editWarehouse = async (data: IVRMWarehouseDetail) => {
        try {
            let params = {
                ...data,
                ...shopAndOrg,
                ...sourceAppOrBranch,
                // createUser: user.username,
                // createUser: userName

            }
            let { retData } = await warehouseService.update(params);
            retData ?
                loadData() && globalPrompt("message", { text: "仓库编辑成功", type: "success" })
                : globalPrompt("message", { text: "仓库编辑失败", type: "error" });
            setSaveLoading(false)
            return retData;
        } catch (error) {
            setSaveLoading(false)
        }
    }


    /**
     * 仓库 货位
     */
    const initShelfDrawer: IVRMTabsDrawerInfo = { visible: false, mode: "add" };
    const [shelfDrawer, setShelfDrawer] = useState<IVRMTabsDrawerInfo>(initShelfDrawer);
    const setIShelfDrawer = (str?: "add" | "edit") => setShelfDrawer(str ? { visible: true, mode: str } : initShelfDrawer);

    const [shelfDataSource, setShelfDataSource] = useState<IVRMshelfDetail[]>([]); //区域数据源
    const [shelfPgCfg, setShelfPgCfg] = useState<TablePaginationConfig>(initPgCfg);  //分页参数
    const [selectedShelfRows, setSelectedShelfRows] = useState<IVRMshelfDetail[]>([]); //多选Shelf行信息
    const [shelfSearch, setShelfSearch] = useState<IVRMshelfSearchFields>({});


    //货位列表 Api
    const shelfLoadData = async (page?: ISearchPage, searchValue: IVRMshelfSearch = shelfSearch) => {
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            warehouseId: editFormVal.id as string,
            warehouseCode: editFormVal.code,
            pageSize: page?.pageSize ?? shelfPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? shelfPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await warehouseService.shelfPage(searchParams);
        const { records, ...pg } = retData;
        setShelfPgCfg(transPgToPagination(pg));
        setShelfDataSource(records);
    }
    //货位重置
    const resetShelf = () => {
        shelfLoadData({
            pageSize: DEFAULT_PAGE_SIZE,
            pageNum: DEFAULT_FIRST_PAGE_NUM
        }, {});
        setShelfSearch({});
    }
    //货位新增 Api
    const insertWarehouseShelf = async (fields: IVRMShelfFormFields) => {
        let { isBatch, num, prefix, startCode, ...val } = fields;
        let data: IVRMshelfInsert = {
            ...val,
            ...shopAndOrg,
            warehouseId: editFormVal.id as string,
            warehouseCode: editFormVal.code,
            // createUser: userName
        }
        let { retData } = await warehouseService.shelfInsert(data);
        if (retData) {
            shelfLoadData();
            globalPrompt("message", { text: "货位新增成功", type: "success" });
            setIShelfDrawer();
        } else {
            globalPrompt("message", { text: "货位新增失败", type: "error" });
        }
    }
    //货位批量新增 Api
    const batchInserttWarehouseShelf = async (fields: IVRMShelfFormFields) => {
        let { isBatch, ...val } = fields;
        let data: IVRMshelfBatchInsert = {
            ...val,
            ...shopAndOrg,
            warehouseId: editFormVal.id as string,
            warehouseCode: editFormVal.code,
            code: "",
            // createUser: userName
        }

        let { retData } = await warehouseService.shelfBatchInsert(data);
        if (retData) {
            shelfLoadData();
            globalPrompt("message", { text: "货位新增成功", type: "success" });
            setIShelfDrawer();
        } else {
            globalPrompt("message", { text: "货位新增失败", type: "error" });
        }
    }

    //货位编辑 Api
    const updateWarehouseShelf = async (fields: IVRMShelfFormFields) => {
        let { isBatch, ...val } = fields;
        let data: IVRMShelfUpdate = {
            ...val,
            id: selectedShelfRows[0].id,
            ...shopAndOrg,
            warehouseId: editFormVal.id as string,
            warehouseCode: editFormVal.code,
        }
        let { retData } = await warehouseService.shelfUpdate(data);
        if (retData) {
            shelfLoadData();
            globalPrompt("message", { text: "货位编辑成功", type: "success" });
            setIShelfDrawer();
        } else {
            globalPrompt("message", { text: "货位编辑失败", type: "error" });
        }
    }

    //货位导入 Api
    const importWarehouseShelf = async (file: File) => {
        let { retData } = await warehouseService.shelfImport({ file: file });
        if (retData) {
            shelfLoadData();
            globalPrompt("message", { text: "货位导入成功", type: "success" });
        } else {
            globalPrompt("message", { text: "货位导入失败", type: "error" });
        }
    }
    const downloadTplShelf = async () => {
        let result = await warehouseService.shelfDownloadTpl();
        convertRes2Blob(result)
    }
    //货位导出
    const exportWarehouseData = async () => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            const searchParams = {
                warehouseId: editFormVal.id,
                warehouseCode: editFormVal.code,
                pageSize: -1,
                pageNum: 1,
            }
            let result = await warehouseService.exportWarehouse(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        editFormVal,
        addWareVisible,
        shelfDataSource,
        shelfPgCfg,
        selectedShelfRows,
        initPgCfg,
        shelfDrawer,
        /***method***/
        setAddWaerVisible,
        updateEditFormVal,
        insertWarehouse,
        editWarehouse,
        getWarehouseOne,
        setDataSource,
        setSelectedRowKeys,
        loadData,
        setIShelfDrawer,
        shelfLoadData,
        insertWarehouseShelf,
        batchInserttWarehouseShelf,
        updateWarehouseShelf,
        importWarehouseShelf,
        setSelectedShelfRows,
        shelfSearch, setShelfSearch, resetShelf, downloadTplShelf,
        saveLoading, setSaveLoading, updateSearchParam, resetSearchParam, exportWarehouseData
    }
});